import React, { Component } from 'react';

import DeviceTypes from '@/constants/DeviceTypes';

export default WrappedComponent =>
  class RequireDeviceHOC extends Component {
    constructor(props) {
      super(props);
      this.state = {
        deviceType: null,
      };
    }

    getDeviceType = () => {
      // Windows只要进入调试模式下就是Android？
      const ua = navigator.userAgent;
      const isWindowsPhone = /(?:Windows Phone)/.test(ua);
      const isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
      const isAndroid = /(?:Android)/.test(ua);
      const isFireFox = /(?:Firefox)/.test(ua);
      const isChrome = /(?:Chrome|CriOS)/.test(ua);
      const isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua));
      const isiPhone = /(?:iPhone)/.test(ua) && !isTablet;
      const isPc = !isiPhone && !isAndroid && !isSymbian;
      const type = {
        isTablet,
        isiPhone,
        isAndroid,
        isPc,
        isChrome,
      };
      if (type.isAndroid || type.isiPhone) {
        return DeviceTypes.MOBILE.TYPE;
      }
      if (type.isTablet) {
        return DeviceTypes.TABLET.TYPE;
      }
      if (type.isPc) {
        return DeviceTypes.DESKTOP.TYPE;
      }
    };

    render() {
      const { devices, unsupportDeviceView, ...otherProps } = this.props;
      return devices && devices.indexOf(this.getDeviceType()) >= 0 ? (
        <WrappedComponent {...otherProps} />
      ) : (
        unsupportDeviceView || null
      );
    }
  };
